var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndesacuerdo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9800;}.cls-2{stroke:#000;stroke-miterlimit:10;stroke-width:13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,120.63c-.22-.63-5.65-15.34-38.85-15.39h-.17c-32.19,0-35.31,13.9-35.43,14.49l0-.18-12.89-1.73c.14-1,4-25.61,48.48-25.58,43.72.07,51,23.64,51.28,24.65l-12.5,3.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48.5,
    cy: 54.75,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 119.5,
    cy: 54.75,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndesacuerdo);
export default __webpack_public_path__ + "static/media/en desacuerdo.5ca31810b5889710bdc3504e76e2d0cf.svg";
export { ForwardRef as ReactComponent };